import React from "react";
import Link from "next/link";
import { useRouter } from "next/router";
import { OPEN_COOKIE_SETTINGS } from "./google-tag-manager-gtm-banner";

const Footer = () => {
  const router = useRouter();
  const isSpanish = router.pathname.startsWith("/es");
  const year = new Date().getFullYear();

  const links = isSpanish
    ? {
        products: { href: "/es/productos", label: "Productos" },
        services: {
          href: "/es/servicios/analisis-de-fluidos",
          label: "Servicios",
        },
        inventory: { href: "/es/inventario", label: "Inventario" },
        contact: { href: "/es/contactenos", label: "Contáctenos" },
        explore: "Explorar",
        tagline:
          "Representante de ventas industrial — hidráulica, neumática, electricidad y mecánica.",
        privacy: "Política de privacidad",
        cookies: "Configuración de cookies",
        terms: "Términos y condiciones",
        legal: "Legal",
        designBy: "Diseño por",
      }
    : {
        products: { href: "/en/products", label: "Products" },
        services: { href: "/en/services/fluid-analysis", label: "Services" },
        inventory: { href: "/en/inventory", label: "Inventory" },
        contact: { href: "/en/contact-us", label: "Contact us" },
        explore: "Explore",
        tagline:
          "Independent industrial sales — hydraulics, pneumatics, electrical, and mechanical.",
        privacy: "Privacy policy",
        cookies: "Cookie settings",
        terms: "Terms and Conditions",
        legal: "Legal",
        designBy: "Design by",
      };

  return (
    <footer className="main-footer tu-footer">
      <div className="tu-container">
        <div className="tu-footer__grid">
          <div>
            <p className="tu-footer__brand">Technical Union</p>
            <p className="tu-footer__tagline">{links.tagline}</p>
          </div>
          <div>
            <p className="tu-footer__heading">{links.explore}</p>
            <ul className="tu-footer__links">
              <li>
                <Link href={links.products.href} prefetch={false}>
                  {links.products.label}
                </Link>
              </li>
              <li>
                <Link href={links.services.href} prefetch={false}>
                  {links.services.label}
                </Link>
              </li>
              <li>
                <Link href={links.inventory.href} prefetch={false}>
                  {links.inventory.label}
                </Link>
              </li>
              <li>
                <Link href={links.contact.href} prefetch={false}>
                  {links.contact.label}
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <p className="tu-footer__heading">{links.legal}</p>
            <ul className="tu-footer__links">
              <li>
                <a
                  href="https://www.tu.biz/privacy-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {links.privacy}
                </a>
              </li>
              <li>
                <button
                  type="button"
                  className="tu-footer__cookie-settings"
                  onClick={() => {
                    window.dispatchEvent(new Event(OPEN_COOKIE_SETTINGS));
                  }}
                >
                  {links.cookies}
                </button>
              </li>
              <li>
                <a href="/terms-and-conditions">{links.terms}</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="tu-footer__bottom">
          <p className="copyright mb-1" suppressHydrationWarning>
            © {year} Technical Union. All rights reserved.
          </p>
          <p className="tu-footer__design-credit">
            {links.designBy} <span className="edgar">Edgar Lindo</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
